module.exports = __webpack_public_path__ + "img/grinning_squinting_face.13c46c9e.gif";